import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import data from '../../assets/data/ver-category';
import VerAddressUserDatatable from '../common/ver-address-user-datatable';
import Modal from 'react-responsive-modal';
import AuthService from '../services/auth.service';
import ApiService, { API_URL } from '../services/api.service';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
registerLocale('es', es);

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Este campo es obligatorio!
      </div>
    );
  }
};

export class Ver_order_collection extends Component {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.onChangeDelivery = this.onChangeDelivery.bind(this);
    this.onChangeReference = this.onChangeReference.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerSeeImage = this.handlerSeeImage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      selectedCategOption: null,
      open: false,
      name: '',
      last_name: '',
      state: '',
      total: 0,
      total_payment: 0,
      pending_payment: 0,
      cash: 0,
      delivery: 0,
      id: '',
      amount: 0,
      errors: {},
      loading: true,
      message: '',
      results: [],
      current_credit: 0,
      delivery: 0,
      reference: '',
      value: 0,
      id_address: null,
      paymentDate: new Date(),
      file_image: null,
      voucher_image: '',
      openModal: false,
      charge: {},
      status_charge: ''
    };
  }

  handleChange(date) {
    this.setState({
      paymentDate: date,
    });
  }

  onChangeDelivery(e) {
    this.setState({
      delivery: e.target.value,
    });
  }

  onChangeReference(e) {
    this.setState({
      reference: e.target.value,
    });
  }

  onChangeValue(e) {
    this.setState({
      value: e.target.value,
    });
  }

  componentWillMount() {
    var id_purchase = this.props.match.params.id;
    this.setState({ id: id_purchase });
    if (id_purchase) {
      this.getDataPurchaseCharge(id_purchase);
    }
  }

  getUser(id_user) {
    var user = AuthService.getCurrentUser();
    ApiService.getUserDetails(user.token, id_user).then(
      (res) => {
        if (res && res.status === 'success') {
          this.setState({ name: res.data.name ? res.data.name : '' });
          this.setState({
            last_name: res.data.last_name ? res.data.last_name : '',
          });
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getDataPurchaseCharge(id_purchase) {
    var user = AuthService.getCurrentUser();
    this.setState({ loading: true, message: '' });
    ApiService.getDataPurchaseCharge(user.token, id_purchase).then(
      (res) => {
        if (res && res.status == 'success') {
          const purchase = res.data && res.data[0];
          if (!purchase) {
            this.setState({ loading: false, message: 'No se encontró la orden.' });
            return;
          }

          var totalPayment = (purchase.payment_amount ? purchase.payment_amount : 0) * 1;
          var totalPending = purchase.pending_amount;

          const items = (purchase.Charge || []).map(function (row) {
            let rowJson = row;
            rowJson.type = 'CHARGE';
            return {
              Id: row.id,
              Monto: row.value ? row.value : '',
              Referencia: row.reference ? row.reference : '',
              ['Fecha Pago']: row.date_payment
                ? Moment(row.date_payment).format('DD/MM/YYYY')
                : '',
              ['Fuente']: row.source,
              data: rowJson,
            };
          });

          this.setState({
            state:         purchase.status_charge,
            name:          purchase.User ? purchase.User.full_name : '',
            status_charge: purchase.status_charge,
            total:         purchase.total,
            total_payment: totalPayment,
            pending_payment: totalPending,
            cash:          purchase.cash,
            delivery:      purchase.delivery,
            results:       items,
            loading:       false,
          });
          this.renderResults();
        } else {
          this.setState({ loading: false, message: 'No se pudo cargar la orden.' });
        }
      },
      (error) => {
        this.setState({ loading: false, message: 'Error al cargar la orden. Intente nuevamente.' });
      }
    );
  }

  clearInputs() {
    this.setState({
      //delivery: "",
      reference: '',
      value: '',
      file_image: null,
      //paymentDate: "",
      loading: false,
      message: '',
    });
  }

  setCharge = (charge) => {
    const newCharge = {
      ...charge,
      date_payment: Moment(charge.date_payment).toDate(),
    };

    this.setState({ charge: newCharge });
  };

  renderResults() {
    return this.state.results.length === 0 ? (
      ''
    ) : (
      <VerAddressUserDatatable
        multiSelectOption={false}
        myData={this.state.results}
        pageSize={
          this.state.results.length <= 10 ? this.state.results.length : 10
        }
        pagination={true}
        class="-striped -highlight"
        handler={this.handler}
        handlerEdit={this.handlerEdit}
        handlerSeeImage={this.handlerSeeImage}
        openModal={() => this.setState({ openModal: true })}
        setCharge={this.setCharge}
      />
    );
  }

  handlerEdit(data_row) {
    //return false

    var user = AuthService.getCurrentUser();

    Swal.fire({
      title: 'Confirmar',
      text: '¿Desea eliminar el pago? Si este pago generó asignaciones en otras órdenes, también se anularán y esas órdenes volverán a Por cobrar.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        ApiService.deletePurchaseCharge(
          user.token,
          data_row.original.data.id
        ).then(
          (res) => {
            if (res && res.status == 'success') {
              toast.success('Pago eliminado!');
              this.getDataPurchaseCharge(this.state.id);
              //this.props.history.push("/category");
              //window.location.reload();
            } else {
              Swal.fire('Aviso!', res.message, 'error');
            }
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();

            /*this.setState({
              loading: false,
              message: resMessage
            });*/
          }
        );
      }
    });
  }

  handlerSeeImage(data_row) {
    this.setState({
      voucher_image: data_row.original.data.voucher_image,
      open: true,
    });
  }

  updateCharge = async () => {
    try {

      var user = AuthService.getCurrentUser();

      // Solo se editan fecha de pago y referencia; el monto se corrige anulando
      // el pago y registrando uno nuevo.
      const { data } = await ApiService.updatePurchaseCharge(
        user.token,
        this.state.charge.id,
        {
          reference: this.state.charge.reference || '',
          date_payment: Moment(this.state.charge.date_payment).format('YYYY-MM-DD'),
        }
      );

      if (data && data.status == 'success') {
        await this.getDataPurchaseCharge(this.state.id);
        this.setState({ openModal: false });
        //toast.success('Pago registrado!');
        Swal.fire('Pago modificado!', '', 'success');
        
      } else {
        Swal.fire('Aviso!', (data && data.message) || 'No se pudo modificar el pago', 'error');
      }
    } catch (e) {
      Swal.fire('Error', 'No se pudo modificar el pago. Intente nuevamente.', 'error');
    }
  };

  handleUpdate(e) {
    //e.preventDefault();

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (
      this.checkBtn.context._errors.length === 0 &&
      !this.state.errors.template
    ) {
      this.onCloseModal('VaryingMdo');
      var user = AuthService.getCurrentUser();
      let select_date = Moment(this.state.paymentDate).format('YYYY-MM-DD');
      let data_user = {
        id_purchase: this.state.id,
        //'id_user': this.state.id,
        value: this.state.value,
        reference: this.state.reference,
        date_payment: select_date,
        voucher_image: this.state.file_image,
      };

      let formdata = new FormData();
      formdata.append('id_purchase', this.state.id);
      formdata.append('date_payment', select_date);
      formdata.append('reference', this.state.reference);
      formdata.append('value', this.state.value);
      formdata.append('voucher_image', this.state.file_image);

      // return true;

      ApiService.postPurchaseCharge(user.token, formdata).then(
        async (res) => {
          if (res && res.status == 'success') {
            await this.getDataPurchaseCharge(this.state.id);
            //toast.success('Pago registrado!');
            Swal.fire('Pago registrado!', '', 'success');
            
          } else {
            Swal.fire('Aviso!', res.message, 'error');
          }

          this.setState({
            loading: false,
          });
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  componentWillReceiveProps() {
    this.getDataPurchaseCharge(this.props.match.params.id);
  }

  handleChangeStatusCharge = async () => {

    this.setState({
      message: '',
      loading: true,
    });
      var user = AuthService.getCurrentUser();
      //let formdata = new FormData();
      //formdata.append('id_purchase', this.state.id);
      //formdata.append('status_charge', this.state.status_charge)

      const data = {
        status_charge: this.state.status_charge,
        id_purchase: this.state.id
      }

      // return true;

      ApiService.updatePurchaseStatusCharge(user.token, data).then(
        async (res) => {
          if (res && res.status == 'success') {
            await this.getDataPurchaseCharge(this.state.id);
            //toast.success('Pago registrado!');
            Swal.fire('Estado modificado!', '', 'success');
            //toast.success('Pago actualizado!');
            //to={`${process.env.PUBLIC_URL}/order-collections/${this.state.id}`}

            //this.clearInputs();
            //this.props.history.push("/category");
            //window.location.reload();
          } else {
            Swal.fire('Aviso!', res ? res.message : 'Error', 'error');
          }

          this.setState({
            loading: false,
          });
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    
  }

  render() {
    const { open } = this.state;
    const { selectedTemplateOption } = this.state;
    const { selectedCategOption } = this.state;

    const _user = AuthService.getCurrentUser();
    let url_image = `${API_URL}voucher/`;
    const voucherToken = _user && _user.token ? `?token=${_user.token}` : '';

    return (
      <Fragment>
        <Breadcrumb title={`Registro de Pagos`} parent="Digital" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          {this.state.loading && (
            <div className="text-center py-5">
              <span className="spinner-border text-primary" style={{ width: 40, height: 40 }} />
              <p className="mt-3 text-muted">Cargando orden...</p>
            </div>
          )}
          {!this.state.loading && this.state.message && (
            <div className="alert alert-danger mx-3">{this.state.message}</div>
          )}
          {!this.state.loading && !this.state.message && <><div className='row'>
          <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                <div className="form-group row">
                  <div className="col-12 col-md-5 mb-2 mb-md-0" style={{ display: 'grid' }}>
                    <label style={{ fontSize: 15 }}>Estado de cobro</label>
                    <select
                      name="name"
                      value={this.state.status_charge}
                      className="form-control"
                      style={{ minHeight: 48, fontSize: 16 }}
                      onChange={(e) => {
                        this.setState({
                          status_charge: e.target.value
                        })
                      }}
                    >
                      <option value="POR_COBRAR">Por cobrar</option>
                      <option value="CANCELADO">Pagado</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-5" style={{ display: 'grid' }}>
                    <button
                      style={{ minHeight: 48, fontSize: 16, alignSelf: 'end' }}
                      className="btn btn-primary"
                      onClick={() => this.handleChangeStatusCharge()}
                    >
                      <span>Guardar</span>
                    </button>
                  </div>
                </div>
                </div>
            </div>
          </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="btn-popup pull-right">
                    <Modal open={open} onClose={this.onCloseModal}>
                      <div className="modal-header">
                        <h5
                          className="modal-title f-w-600"
                          id="exampleModalLabel2"
                        >
                          Voucher
                        </h5>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12">
                            <img
                              src={url_image + this.state.voucher_image + voucherToken}
                              alt="Voucher"
                              data-protected="1"
                              style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', display: 'block', margin: '0 auto' }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => this.onCloseModal('VaryingMdo')}
                        >
                          Cancelar
                        </button>
                      </div>

                      {this.state.message && (
                        <div className="form-group">
                          <div className="alert alert-danger" role="alert">
                            {this.state.message}
                          </div>
                        </div>
                      )}
                    </Modal>
                  </div>
                  {/* <div className="clearfix"></div> */}
                  <div className="clearfix">
                    <Link to={`${process.env.PUBLIC_URL}/collections`}>
                      <span>
                        <i
                          className="fa fa-arrow-left"
                          style={{
                            width: 35,
                            fontSize: 20,
                            marginBottom: '20px',
                            color: 'rgb(14 14 14)',
                          }}
                        ></i>
                      </span>
                    </Link>
                  </div>
                  <div id="basicScenario" className="product-physical">
                    <div style={{ marginBottom: '15px' }}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Nro Orden:
                              </label>
                              {this.props.match.params.id}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Cliente:
                              </label>
                              {this.state.name}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Total:
                              </label>
                              {this.state.total}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Delivery:
                              </label>
                              {this.state.delivery}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Cash:
                              </label>
                              {this.state.cash}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Estado:
                              </label>
                              {this.state.state}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Total Pagado:
                              </label>
                              {this.state.total_payment}
                            </div>
                            <div className="col-md-12">
                              <label
                                style={{
                                  marginRight: '5px',
                                  fontWeight: '700',
                                }}
                              >
                                Total Pendiente:
                              </label>
                              {this.state.pending_payment}
                            </div>
                          </div>
                        </div>
                      </div>

                     
                    </div>
                    <Form
                      id="frmCateg"
                      //onSubmit={this.state.register?this.handleUpdate:this.handleUpdate}
                      encType="multipart/form-data"
                      method="POST"
                      ref={(c) => {
                        this.form = c;
                      }}
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="form-group row">
                        <div className="col-12 col-md-5 mb-2 mb-md-0" style={{ display: 'grid' }}>
                          <label style={{ fontSize: 15 }}>Referencia</label>
                          <Input
                            name="name"
                            value={this.state.reference}
                            type="text"
                            className="form-control"
                            style={{ minHeight: 48, fontSize: 16 }}
                            onChange={this.onChangeReference}
                          />
                        </div>
                        <div className="col-12 col-md-5" style={{ display: 'grid' }}>
                          <label style={{ fontSize: 15 }}>Valor</label>
                          <Input
                            name="name"
                            value={this.state.value}
                            type="number"
                            className="form-control"
                            style={{ minHeight: 48, fontSize: 16 }}
                            onChange={this.onChangeValue}
                            validations={[required]}
                            min="1"
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-12 col-md-5 mb-2 mb-md-0" style={{ display: 'grid' }}>
                          <label style={{ fontSize: 15 }}>Voucher</label>
                          <Input
                            name="url"
                            type="file"
                            className="form-control"
                            style={{ minHeight: 48, fontSize: 15, paddingTop: 10 }}
                            accept="image/*"
                            onChange={(e) => {
                              this.setState({ file_image: e.target.files[0] });
                            }}
                          />
                        </div>
                        <div className="col-12 col-md-3 mb-2 mb-md-0" style={{ display: 'grid' }}>
                          <label style={{ fontSize: 15 }}>Fecha de Pago</label>
                          <DatePicker
                            selected={this.state.paymentDate}
                            onChange={this.handleChange}
                            locale="es"
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            wrapperClassName="w-100"
                            customInput={
                              <input
                                className="form-control"
                                style={{ minHeight: 48, fontSize: 16 }}
                              />
                            }
                          />
                        </div>
                        <div className="col-12 col-md-2" style={{ display: 'grid' }}>
                          <button
                            style={{ minHeight: 48, fontSize: 16, alignSelf: 'end' }}
                            className="btn btn-primary"
                            disabled={this.state.loading}
                            onClick={() => this.handleUpdate()}
                          >
                            {this.state.loading && (
                              <span className="spinner-border spinner-border-sm"></span>
                            )}
                            <span>Guardar</span>
                          </button>
                        </div>
                      </div>
                      {this.state.message && (
                        <div className="form-group">
                          <div className="alert alert-danger" role="alert">
                            {this.state.message}
                          </div>
                        </div>
                      )}
                      <CheckButton
                        style={{ display: 'none' }}
                        ref={(c) => {
                          this.checkBtn = c;
                        }}
                      />
                    </Form>
                    {this.renderResults()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>}
        </div>
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
        >
          <div className="modal-header">
            <h5 className="modal-title f-w-600" id="exampleModalLabel2">
              Orden n°
            </h5>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div className="product-physical">
                        <div className="form-group row">
                          <div className="col-12 col-md-6 mb-2 mb-md-0" style={{ display: 'grid' }}>
                            <label style={{ fontSize: 15 }}>Referencia</label>
                            <input
                              name="name"
                              value={this.state.charge.reference}
                              type="text"
                              className="form-control"
                              style={{ minHeight: 48, fontSize: 16 }}
                              onChange={(e) => {
                                this.setState({
                                  charge: {
                                    ...this.state.charge,
                                    reference: e.target.value,
                                  },
                                });
                              }}
                              autoFocus
                            />
                          </div>
                          <div className="col-12 col-md-6" style={{ display: 'grid' }}>
                            <label style={{ fontSize: 15 }}>Valor</label>
                            <input
                              name="name"
                              value={this.state.charge.value}
                              type="number"
                              className="form-control"
                              style={{ minHeight: 48, fontSize: 16 }}
                              disabled
                            />
                            <small className="text-muted">
                              Para corregir el monto, elimine este pago (queda registrado como anulado) y registre uno nuevo.
                            </small>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-12 col-md-6 mb-2 mb-md-0" style={{ display: 'grid' }}>
                            <label style={{ fontSize: 15 }}>Fecha de Pago</label>
                            <DatePicker
                              selected={this.state.charge.date_payment}
                              onChange={(date) => {
                                this.setState({
                                  charge: {
                                    ...this.state.charge,
                                    date_payment: date,
                                  },
                                });
                              }}
                              locale="es"
                              dateFormat="dd/MM/yyyy"
                              customInput={
                                <input
                                  className="form-control"
                                  style={{ minHeight: 48, fontSize: 16 }}
                                />
                              }
                            />
                          </div>
                          <div className="col-12 col-md-6" style={{ display: 'grid' }}>
                            <label style={{ fontSize: 15 }}>Estado</label>
                            <input
                              type="text"
                              className="form-control"
                              style={{ minHeight: 48, fontSize: 16 }}
                              value={
                                this.state.charge.state === 'PENDIENTE_VERIFICACION'
                                  ? 'Pendiente de verificación'
                                  : this.state.charge.state === 'ACTIVO'
                                  ? 'Activo'
                                  : this.state.charge.state || ''
                              }
                              disabled
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-12 col-md-4" style={{ display: 'grid' }}>
                            <button
                              className="btn btn-primary"
                              onClick={() => this.updateCharge()}
                              style={{ minHeight: 48, fontSize: 16, marginTop: '1rem' }}
                            >
                              {this.state.loading && (
                                <span className="spinner-border spinner-border-sm mr-1"></span>
                              )}
                              <span>Guardar</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer"></div>
        </Modal>
      </Fragment>
    );
  }
}

export default Ver_order_collection;
